// STATE: Bonds up to $500 penal liability, a minimum of $50 per bond
// Bonds of $500 to $5,000 penal liability, 10% of penal liability 
// Bonds larger than $5,000 penal liability, 7% of penal liability plus $150.                        

// IMMIGRATION: 15% of the penal amount. $100 minimum. The premium will be charged and collected on an annual basis until the surety is legally discharged from all liability on the bond(s). 

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = 0
  if (type === 'STATE') {
    if (bondValue < 500) {
      value = premium
      minimum = 50
      if (value < 50) {
        value = 50
        condition = 'Minimum not met'
      }
    } else if (bondValue >= 500 && bondValue < 5000) {
      value = (bondValue * .1)
    } else if (bondValue >= 5000) {
      value = (bondValue * .07)
      value += 150
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation

